import * as React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { LifeChangeBankingDetailsDebicheck } from './LifeChangeBankingDetailsDebicheck';
import './LifeChangeBankingDetailsFooter.css';

export interface LifeChangeBankingDetailsFooterProps {
    saving: boolean;
    error: any;
    success: any;
    debicheckSaving: boolean;
    debicheckError: any;
    debicheckSuccess: any;
    emitHandleValidate: any;
    debitOrderDate: string;
    debitOrderDateDay: string;
    premium: string;
    bankName: string;
    accountNumber: string;
    emitHandleDebicheckContinue;
}

interface State {

}

export class LifeChangeBankingDetailsFooter extends React.Component<LifeChangeBankingDetailsFooterProps,State> {
    constructor(props: LifeChangeBankingDetailsFooterProps) {
        super(props);

        this.state = {
            
        }

        this.handleDebicheckContinue = this.handleDebicheckContinue.bind(this);
    }

    handleDebicheckContinue(e: any) {
        this.props.emitHandleDebicheckContinue(e);
    }

    public render() {
        return <div className="life-change-banking-details-footer">
            { !this.props.success && <>
                <Button onClick={this.props.emitHandleValidate} className="life-change-banking-details-footer__validate btn btn-solid-red mt-3">
                    {!this.props.saving && <>Validate</>
                        ||
                        <Spinner className="d-block mx-auto" animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner> }
                </Button>
                { this.props.error && <>
                    {this.props.error && <p className="mt-3 life-change-banking-details-footer__error-message">{ this.props.error }</p> }
                </>}
                <div className="col-12 schedule-special-debit__secure life-change-banking-details-footer__disclosure text-center row justify-content-center align-items-center flex-nowrap">
                    <div className="col-auto">
                        <img className="d-inline-block" src="./Images/LifeInsurance/icon-lock.png" />
                    </div>
                    <div className="col-auto">
                        <p className="d-inline-block text-left mb-0">
                            <strong>Secure connection</strong>. Your info’s encrypted, which means it’s totally safe with us
                        </p>
                    </div>
                </div>
            </> }
            {this.props.success && <div>
                <div className="life-change-banking-details-footer__success">
                    <img className="life-change-banking-details-footer__success__img" src="./Images/TopNav/icon-checkmark-nugreen-32px-32px.svg" />
                    <p className="life-change-banking-details-footer__success__text">Validated</p>
                </div>
                <hr className="noma nopa change-banking-details__hr" />
                <LifeChangeBankingDetailsDebicheck
                    saving={this.props.debicheckSaving}
                    error={this.props.debicheckError}
                    success={this.props.debicheckSuccess}
                    emitHandleContinue={this.handleDebicheckContinue}
                    accountNumber={this.props.accountNumber}
                    bankName={this.props.bankName}
                    debitOrderDate={this.props.debitOrderDate}
                    premium={this.props.premium}
                    debitOrderDateDay={this.props.debitOrderDateDay}
                >
                    
                </LifeChangeBankingDetailsDebicheck>
            </div> }

        </div>
    }
}